<template>
  <v-row
    dense
    align-content="space-between"
    class="mb-2"
  >
    <v-col class="text-left">
      <h3 class="bc-page-title">
        <template v-if="breadCrumb">
          <router-link
            class="link-emb"
            :to="{ name: breadCrumb.route }"
          >
            <v-icon
              class="pt-0"
              v-if="breadCrumb.icon"
              color="white"
              >mdi-{{ breadCrumb.icon }}</v-icon
            >
            {{ breadCrumb.page_title }}
          </router-link>
          /
        </template>
        <v-icon
          v-if="icon || faicon"
          color="white"
          >{{ icon ? 'mdi' : 'fa' }}-{{ icon || faicon }}</v-icon
        >
        {{ page_title }}
        <div>
          <slot name="tour"></slot>
        </div>
      </h3>

    </v-col>
    <v-col
      md="2"
      lg="2"
      sm="2"
      cols="6"
      class="text-right"
    >
      <slot name="buttons"></slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    page_title: {
      required: false,
      type: String,
    },

    icon: {
      required: false,
      type: String,
    },

    faicon: {
      required: false,
      type: String,
    },

    breadCrumb: {
      required: false,
      default: null,
      type: Object,
    },
  },
};
</script>

<style scoped>
.bc-page-title {
  color: #fff;
}

.link-emb {
  text-decoration: none;
  color: #fff !important;
}
</style>
